import { PurchaseIntention } from '@/app/purchase-intention/entities/purchase-intention.entity'

export interface PurchaseIntentionState {
    purchaseIntentions: PurchaseIntention[]
}

export const state: PurchaseIntentionState = {
    purchaseIntentions: []
}
